module.exports = __webpack_public_path__ + "static/media/congratulation-icon.18469575.png";